import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { verifyConnector } from '../../server/connector/verifyConnector'
import CtaButton from '../../components/ctaButton/CtaButton'

function VerifyEmailPage() {

	const [verifySuccess, setVerifySuccess] = useState<boolean>(false)
	const [verifyRequestComplete, setVerifyRequestComplete] = useState<boolean>(false)

	useEffect(() => {
		attemptVerify()
	}, [])

	const attemptVerify = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const verifyCode: string | null = urlParams.get('code')

		if (verifyConnector.requestInProgress) {
			console.log('[VerifyEmail] - requestProfile() called while requestInProgress')
		} else {
			if (verifyCode) {
				verifyConnector.verifyEmailRequest(verifyCode).then((successRequest) => {
					setVerifyRequestComplete(true)
					if (successRequest) {
						setVerifySuccess(true)
						window.location.replace(PAGE_URLS.LOG_IN)
					}
				})
			}
		}
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='thank-you-content'>
						<div className='sign-up-content-section'>
							<div className='thank-you-message-wrap'>
								<div className='thank-you-message'>
									{verifyRequestComplete ?
										<div className='sign-up-form-label-txt'>
											{verifySuccess ? 'Your email was verified Successfully, you can now sign in.' : 'Failed to verify email, please contact support.'}
										</div>
										:
										<div className='sign-up-form-label-txt'>
											Verifying Your Email...
										</div>
									}
								</div>
								<div className='thank-you-button-wrap'>
									<CtaButton
										label='Back to Home'
										onClick={() => {
											window.location.replace(PAGE_URLS.SEARCH)
										}}
										size='medium'
										fullWidth={true}
									/>
									<CtaButton
										label='Sign In'
										onClick={() => {
											window.location.replace(PAGE_URLS.LOG_IN)
										}}
										size='medium'
										fullWidth={true}
									/>
								</div>
							</div>
						</div>
						<div className='sign-up-content-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/ski-lift.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default VerifyEmailPage
